import { useState, useEffect } from "react";

/**
 * Custom hook to detect portrait/mobile orientation
 * @returns {boolean} true if device is in portrait mode
 */
function usePortrait() {
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  useEffect(() => {
    const mql = window.matchMedia("(orientation: portrait)");
    const onChange = (e) => setIsPortrait(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isPortrait;
}

export default usePortrait;
